<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="courses"
            dense
        >
            
        </v-data-table>
    </div>
</template>
<script>
export default {
    props: ['courses'],
    data: function () {
        return {
            docView:false,
            url:'',
            headers:[
                {text: 'Course', value:'name'},
                {text: 'Description', value:'description'},
                {text: 'Difficulty', value:'difficulty'},
                {text: 'Organization', value:'organization_uuid'},
                {text: 'Status', value:'status'},
            ]
        }
    },
    mounted() {
        console.log(this.documents);
    },
    methods: {
        openFile: function (itm){
            this.url = itm;
            this.docView = true;
        }
    }
}
</script>